import React, { FunctionComponent } from 'react';
import Globe from 'app/components/svgs/Globe';
import { Language } from 'app/constants/enums/Language';
import { List } from 'immutable';
import { useI18n } from 'app/components/localization';
import { NavButton } from 'app/components/presentation/nav/NavLink';
import NavDropdown from 'app/components/presentation/nav/NavDropdown';

interface IProps {
  currentLanguage: string;
  languages: List<Language>;
  setLanguage: (lang: string) => void;
}

const LanguageDropdown: FunctionComponent<IProps> = ({ currentLanguage, languages, setLanguage }) => {
  const { t } = useI18n();
  return (
    <NavDropdown alignRight showArrow={false} icon={<Globe size="20px" />} renderHidden={false}>
      {languages.map(language => (
        <NavButton
          key={language.id}
          selected={language.id === currentLanguage}
          onClick={() => setLanguage(language.id)}
        >
          {language.getNative(t)}
        </NavButton>
      ))}
    </NavDropdown>
  );
};

export default LanguageDropdown;
